export type ScorecardSeriesConfig = {
  id: string;
  label: string;
  fieldId: string;
  color: string;
};

export type ScorecardChartConfig = {
  id: string;
  title: string;
  noteFieldId: string;
  series: ScorecardSeriesConfig[];
};

export const SCORECARD_SECTION_ID = 'sec_scheda-di-valutazione';
export const SCORECARD_DATE_FIELD_ID = 'fld_data-valutazione';
export const SCORECARD_MAX_POINTS = 4;
export const SCORECARD_HISTORY_POINTS = Math.max(0, SCORECARD_MAX_POINTS - 1);

export const SCORECARD_CHARTS: ScorecardChartConfig[] = [
  {
    id: 'disponibilita',
    title: 'Disponibilità al sopralluogo',
    noteFieldId: 'fld_note-disponibilita',
    series: [
      {
        id: 'pianificazione',
        label: 'Pianificazione',
        fieldId: 'fld_disp-pianificazione',
        color: '#052664',
      },
      {
        id: 'personale-patentato',
        label: 'Presenza personale patentato',
        fieldId: 'fld_disp-presenza-personale-patentato',
        color: '#EF4444',
      },
      {
        id: 'formazione',
        label: 'Partecipazione alla formazione',
        fieldId: 'fld_disp-partecipazione-formazione',
        color: '#16A34A',
      },
      {
        id: 'prove',
        label: 'Esecuzione delle prove',
        fieldId: 'fld_disp-esecuzione-prove',
        color: '#7C3AED',
      },
    ],
  },
  {
    id: 'interesse',
    title: 'Livello di interesse e attenzione',
    noteFieldId: 'fld_note-interesse',
    series: [
      {
        id: 'sopralluogo',
        label: 'Durante il sopralluogo',
        fieldId: 'fld_int-durante-sopralluogo',
        color: '#052664',
      },
      {
        id: 'formazione',
        label: 'Durante la formazione',
        fieldId: 'fld_int-durante-formazione',
        color: '#EF4444',
      },
      {
        id: 'conoscenze',
        label: 'Approfondimento conoscenze',
        fieldId: 'fld_int-approfondimento-conoscenze',
        color: '#16A34A',
      },
      {
        id: 'sensibilita',
        label: 'Sensibilità alla sicurezza',
        fieldId: 'fld_int-sensibilita-sicurezza',
        color: '#7C3AED',
      },
    ],
  },
  {
    id: 'efficienza',
    title: 'Stato di efficienza',
    noteFieldId: 'fld_note-efficienza',
    series: [
      {
        id: 'ordine',
        label: 'Ordine dei locali',
        fieldId: 'fld_eff-ordine-locali',
        color: '#052664',
      },
      {
        id: 'pulizia',
        label: 'Pulizia dei locali',
        fieldId: 'fld_eff-pulizia-locali',
        color: '#EF4444',
      },
      {
        id: 'risposta',
        label: 'Tempi di risposta a richieste',
        fieldId: 'fld_eff-tempi-risposta',
        color: '#16A34A',
      },
      {
        id: 'esecuzione',
        label: 'Tempi di esecuzione interventi',
        fieldId: 'fld_eff-tempi-esecuzione',
        color: '#7C3AED',
      },
      {
        id: 'puntualita',
        label: 'Puntualità interventi periodici',
        fieldId: 'fld_eff-puntualita-interventi',
        color: '#0EA5E9',
      },
    ],
  },
  {
    id: 'documentale',
    title: 'Stato documentale',
    noteFieldId: 'fld_note-documentale',
    series: [
      {
        id: 'accesso',
        label: 'Facilità accesso ai documenti',
        fieldId: 'fld_doc-facilita-accesso',
        color: '#052664',
      },
      {
        id: 'completezza',
        label: 'Completezza informazioni',
        fieldId: 'fld_doc-completezza',
        color: '#EF4444',
      },
    ],
  },
  {
    id: 'sicurezza',
    title: 'Livello di sicurezza complessivo',
    noteFieldId: 'fld_note-sicurezza',
    series: [
      {
        id: 'complessivo',
        label: 'Sicurezza complessiva',
        fieldId: 'fld_sicurezza-complessiva',
        color: '#052664',
      },
    ],
  },
];

export const SCORECARD_SERIES_FIELD_IDS = SCORECARD_CHARTS.flatMap((chart) =>
  chart.series.map((series) => series.fieldId)
);

export const SCORECARD_FIELD_TO_CONTEXT_KEY = {
  'fld_disp-pianificazione': 'disponibilitaPianificazione',
  'fld_disp-presenza-personale-patentato': 'disponibilitaPersonale',
  'fld_disp-partecipazione-formazione': 'disponibilitaFormazione',
  'fld_disp-esecuzione-prove': 'disponibilitaProve',
  'fld_int-durante-sopralluogo': 'interesseSopralluogo',
  'fld_int-durante-formazione': 'interesseFormazione',
  'fld_int-approfondimento-conoscenze': 'interesseConoscenze',
  'fld_int-sensibilita-sicurezza': 'interesseSicurezza',
  'fld_eff-ordine-locali': 'efficienzaOrdine',
  'fld_eff-pulizia-locali': 'efficienzaPulizia',
  'fld_eff-tempi-risposta': 'efficienzaRisposta',
  'fld_eff-tempi-esecuzione': 'efficienzaEsecuzione',
  'fld_eff-puntualita-interventi': 'efficienzaPuntualita',
  'fld_doc-facilita-accesso': 'documentaleAccesso',
  'fld_doc-completezza': 'documentaleCompletezza',
  'fld_sicurezza-complessiva': 'sicurezzaComplessiva',
} as const;
